// src/lib/sheets.js
const API_BASE = process.env.REACT_APP_API_BASE || "";

/**
 * Direkter Google Sheets Call (nur für Tests/Local).
 * Achtung: Benötigt öffentlich freigegebenes Sheet ODER OAuth/SA.
 */
export async function fetchSheetValues({ sheetId, range, apiKey }) {
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${sheetId}/values/${encodeURIComponent(range)}?key=${apiKey}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });

    if (!res.ok) {
        const text = await safeText(res);
        throw new Error(`Sheets API ${res.status}: ${text.slice(0, 200)}`);
    }

    const json = await safeJson(res);
    return normalizeSheet(json);
}

/**
 * Preferred: über deinen PHP-Proxy (/backend/sheets.php).
 * Fängt HTML-Fehler (Rewrite/404/500) ab und liefert klare Fehlermeldungen.
 */
export async function fetchSheetViaProxy({ range, sheetId }) {
    const params = new URLSearchParams();
    params.set("range", range);
    if (sheetId) params.set("sheetId", sheetId);

    const url = `${API_BASE}/backend/sheets.php?${params.toString()}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });

    if (!res.ok) {
        const text = await safeText(res);
        throw new Error(`Proxy ${res.status}: ${text.slice(0, 200)}`);
    }

    const ct = (res.headers.get("content-type") || "").toLowerCase();
    const body = await res.text();

    if (!ct.includes("application/json") && body.trim().startsWith("<")) {
        throw new Error("Proxy lieferte HTML statt JSON.");
    }

    let json;
    try {
        json = JSON.parse(body);
    } catch {
        throw new Error(`Ungültiges JSON vom Proxy: ${body.slice(0, 200)}`);
    }

    return normalizeSheet(json);
}
/* -------------------- Helfer -------------------- */

function normalizeSheet(json) {
    const values = json?.values || [];
    if (!values.length) return { header: [], rows: [] };

    const [header, ...rest] = values;
    const rows = rest.map((r) =>
        Object.fromEntries(header.map((h, i) => [h || `col${i + 1}`, r[i] ?? ""]))
    );
    return { header, rows };
}

async function safeText(res) {
    try { return await res.text(); } catch { return ""; }
}

async function safeJson(res) {
    const t = await safeText(res);
    try { return JSON.parse(t); } catch { throw new Error(`Ungültiges JSON: ${t.slice(0, 200)}`); }
}
